import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { ChatContainer, MessageList } from '../../styled/Chatbox';
import { CreateButton } from '../components/Button';
import { ErrorMessage, FormInput, InlineInput, RadioInput, RadioLabel } from '../components/Form';
import { MessageBot, MessageSelf } from './Message';

const username = "Anonymous";
const userid = Date.now();

const Chatbox = ({
    data
}) => {
  const [messages, setMessages] = useState([]);
  const [modelType, setModelType] = useState("gpt35");
  const [newMessage, setNewMessage] = useState('');
  const [botMessage, setBotMessage] = useState('');
  const [error, setError] = useState(null);
  const messageContainerRef = useRef();

  const handleSendMessage = async () => {
    setError(null);

    if (newMessage.trim() !== '') {
        setMessages([...messages, {
            message: newMessage,
            type: 'self'
        }]);

        let form = JSON.stringify({
            "user_text": newMessage,
            "user_id": userid,
            "kata_client_id": data.kata_client_id,
            "prompt_tag": "",
            "user_name": username,
        });
    
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_CHATBOT_URL}?model_type=${modelType}`,
            headers: { 
              'Content-Type': 'application/json'
            },
            data : form
        };
    
        await axios.request(config)
            .then((response) => {
                if (response.data && response.data.data) {
                    setBotMessage([{
                        message: response.data.data,
                        type: 'bot'
                    }]);
                }
            })
            .catch((error) => {
                setError(error.message);
            });

        setNewMessage('');
    }
  };

  useEffect(() => {
    setMessages([...messages, ...botMessage])
    // eslint-disable-next-line
  }, [botMessage])

  useEffect(() => {
    if (messages.length > 0 && messageContainerRef.current) {
        messageContainerRef.current.scrollTop = messageContainerRef.current.scrollHeight;
    }
    // eslint-disable-next-line
  }, [messages])

  return (
    <ChatContainer>
        {error && <ErrorMessage>{error}</ErrorMessage>}
        {messages.length > 0 && <CreateButton variant="#d94115" pullright={true} onClick={() => setMessages([])}>Clear Chat</CreateButton>}
        <MessageList ref={messageContainerRef}>
            {messages.map((message, index) => message.type === "bot" ? (
                        <MessageBot key={index} text={message.message} />
                    )
                :
                    (
                        <MessageSelf key={index} text={message.message} />
                    )
            )}
        </MessageList>
        <InlineInput>
            <RadioLabel>
                <RadioInput
                    type="radio"
                    name="model_type"
                    checked={modelType === "gpt35"}
                    onChange={(e) => 
                        setModelType("gpt35")
                    }
                />
                GPT 3.5
            </RadioLabel>
            <RadioLabel>
                <RadioInput
                    type="radio"
                    name="model_type"
                    checked={modelType === "gpt4"}
                    onChange={(e) => 
                        setModelType("gpt4")
                    }
                />
                GPT 4.0
            </RadioLabel>
            <RadioLabel>
                <RadioInput
                    type="radio"
                    name="model_type"
                    checked={modelType === "vertex"}
                    onChange={(e) => 
                        setModelType("vertex")
                    }
                />
                Vertex
            </RadioLabel>
        </InlineInput>
        <InlineInput>
            <FormInput
                type="text"
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && newMessage !== "" && handleSendMessage()}
            />
            <CreateButton pullright="true" onClick={handleSendMessage}>Send</CreateButton>
        </InlineInput>
    </ChatContainer>
  );
};

export default Chatbox;
